import { render, staticRenderFns } from "./logEntryFlex.vue?vue&type=template&id=3b387136&scoped=true&"
import script from "./logEntryFlex.vue?vue&type=script&lang=ts&"
export * from "./logEntryFlex.vue?vue&type=script&lang=ts&"
import style0 from "./logEntryFlex.vue?vue&type=style&index=0&id=3b387136&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b387136",
  null
  
)

export default component.exports